import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Gift, Zap, Lock } from 'lucide-react';
export function Header() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Track AddToCart event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Quincena Milagrosa',
        content_ids: ['42994498404470'],
        content_type: 'product',
        value: 7.97,
        currency: 'USD'
      });
    }
  };
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} className="sticky top-0 z-50 bg-amber-900 text-amber-50 shadow-lg" data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="flex flex-col md:flex-row items-center justify-between py-3 space-y-2 md:space-y-0" data-id="element-83">
          {/* Benefits Bar */}
          <div className="flex flex-wrap justify-center md:justify-start gap-4 text-xs sm:text-sm font-medium opacity-90" data-id="element-84">
            <div className="flex items-center gap-1.5" data-id="element-85">
              <CreditCard className="w-4 h-4 text-amber-400" data-id="element-86" />
              <span data-id="element-87">Pago único: $7.97 USD</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-88">
              <Gift className="w-4 h-4 text-amber-400" data-id="element-89" />
              <span data-id="element-90">Incluye 3 bonos</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-91">
              <Zap className="w-4 h-4 text-amber-400" data-id="element-92" />
              <span data-id="element-93">Acceso inmediato</span>
            </div>
            <div className="hidden sm:flex items-center gap-1.5" data-id="element-94">
              <Lock className="w-4 h-4 text-amber-400" data-id="element-95" />
              <span data-id="element-96">Sin suscripciones</span>
            </div>
          </div>

          {/* CTA */}
          <a href="https://almadigitalebooks.digital/cart/42994498404470:1" onClick={handleCTAClick} className="bg-gradient-to-r from-amber-400 to-orange-500 text-amber-950 font-bold py-1.5 px-4 rounded-full text-sm hover:shadow-lg hover:scale-105 transition-all duration-300 shadow-amber-900/20" data-id="element-97">
            👉 Empieza desde tu próxima quincena
          </a>
        </div>
      </div>
    </motion.header>;
}